export default function MySQL_ALIASES() {
  return (
    <div>
      <h2>MySQL_ALIASES</h2>    </div>
  );
}